import './App.css';
import React, { useEffect } from 'react';
import AOS from 'aos';
import './aos.css';
import { Routes, Route, Navigate } from 'react-router-dom';

// import Navbar from './components/Navbar';
import SliderSec from './components/home/SliderSec';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';


import Contact from './components/contact/Contact';
import About from './components/about/About';
import NavbarD from './components/NavbarD';
import AboutH from './components/home/AboutH';
import ServiceSlider from './components/home/ServiceSlider';
import Industry from './components/home/Industry';
import WhyChooseUs from './components/home/WhyChooseUs';
import Testimonial from './components/home/Testimonial';
import Corp from './components/corporate-registration/Corp';
import SalesTax from './components/SalesTax/SalesTax';
import Licenses from './components/Licenses/Licenses';
// import BankAccountAssistance from './components/Bank-account-assistance/BankAccountAssistance';
import Bookkeeping from './components/bookkeeping/Bookkeeping';
import TaxFiling from './components/TaxFiling/TaxFiling';
import TaxConsultation from './components/TaxConsult/TaxConsultation';
import PayrollSer from './components/PayrollSer/PayrollSer';
import Insurance from './components/insurance/Insurance';
import FourOneKAssistance from './components/401K/FourOneKAssistance';
import Accounting from './components/Accounting/Accounting';
// import NotarySol from './components/NotarySol/NotarySol';
import NriService from './components/NRI/NriService';
import Irs from './components/ItIrs/Irs';
// import GroupofCompany from './components/GroupofCompany';
import PrivacyPolicy from './components/Priavcy/PrivacyPolicy';
import Terms from './components/Terms/Terms';
import ThankYou from './components/ThankYou';
import IndividualTaxFiling from './components/individual-tax-filing/IndividualTaxFiling';
import ITRTaxFiling from './components/itr-tax-filing/ITRTaxFiling';
import New from './components/new-landing/TypesOfPermitInUSA';
import TypesOfPermitInUSA from './components/new-landing/TypesOfPermitInUSA';
import AdmendmentsAndCorrectionChargesInUsa from './components/new-landing/AdmendmentsAndCorrectionChargesInUsa';
import NewCorporationInTheUSA from './components/new-landing/NewCorporationInTheUSA';
import FIRSTDBAFilingWithCorporationUSA from './components/new-landing/FIRSTDBAFilingWithCorporationUSA';
import SecondDBARegistrationUSA from './components/new-landing/SecondDBARegistrationUSA';
import SalesTaxSolutionUSA from './components/new-landing/SalesTaxSolutionUSA';
import TobaccoLicensesInUSA from './components/new-landing/TobaccoLicensesInUSA';
import TexasAlcoholicBeverageCommissionLicenseInUSA from './components/new-landing/TexasAlcoholicBeverageCommissionLicenseInUSA';
import TCEQ from './components/new-landing/TCEQ';
import WMC from './components/new-landing/WMC';
import MSB from './components/new-landing/MSB';
import FSAT from './components/new-landing/FSAT';
import HPBU from './components/new-landing/HPBU';
import OCUR from './components/new-landing/OCUR';
import FPLU from './components/new-landing/FPLU';
import LBLU from './components/new-landing/LBLU';
import NotFoundPage from './components/NotFoundPage';
import Admin from './components/admin/admin';
import { useState } from 'react';
import AnimatedCursor from 'react-animated-cursor';
import Navbar_O from './components/Navbar_O';
import Appointment from './components/Appointment';
import AMCPAPLLC from './components/AMCPAPLLC/AMCPAPLLC';





function App() {









  const [currentPage, setCurrentPage] = useState('')
  useEffect(() => {
    // const pathSegments = window.location.pathname.split('/');
    // const lastPart = pathSegments[pathSegments.length - 1];
    setCurrentPage(window.location.pathname.split('/').pop())


    AOS.init({
      duration: 1000,  // Animation speed
      once: true,      // Animation will only happen once
      easing: 'ease-in-out',
    });
    AOS.refresh();
  }, []);

  return (






    <>
      {/*  <BrowserRouter> */}




      {currentPage !== 'admin' &&
        <>
          <div className="download-brochure-container row">
            <a href={require('./components/img/SBA-AM-CPA-PLLC-Brochure.pdf')} download className="brochure-link">
              Download Brochure
            </a>
            <i className="bi bi-file-earmark-pdf brochure-icon"></i>
          </div>
        </>

      }




      {/* {currentPage !== 'admin' && <NavbarD></NavbarD>} */}



      <>
        <Navbar_O />
        <section className='height-100'></section></>

      {/*      
      <Navbar_O />
      <section className='height-100'></section> */}


      {/* <NavbarD></NavbarD> */}
      {/* {currentPage !== 'admin' && <section className='height-100'></section>} */}
      <Routes>



        <Route exact path='/' element={
          <>
            <SliderSec />
            <AboutH></AboutH>
            <ServiceSlider />
            <Industry></Industry>
            <WhyChooseUs></WhyChooseUs>
            <Testimonial></Testimonial>
            <ContactForm></ContactForm>
          </>
        } />


        <Route path='am-cpa-pllc' element={
          <>
            <AMCPAPLLC />
            {/* <GroupofCompany></GroupofCompany> */}

          </>
        } />




        <Route path='about-us' element={
          <>
            <About></About>
            {/* <GroupofCompany></GroupofCompany> */}

          </>
        } />

        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />

        <Route path='corporate-registration' element={
          <>
            <Corp></Corp>
            <ServiceSlider />

          </>
        } />

        <Route path='sales-tax' element={
          <>
            <SalesTax></SalesTax>
            <ServiceSlider />

          </>
        } />

        <Route path='license' element={
          <>
            <Licenses></Licenses>
            <ServiceSlider />

          </>
        } />

        <Route path='bookkeeping-and-business-consulting' element={
          <>
            <Bookkeeping></Bookkeeping>
            <ServiceSlider />

          </>
        } />

        <Route path='tax-filing' element={
          <>
            <TaxFiling></TaxFiling>
            <ServiceSlider />

          </>
        } />

        <Route path='tax-consultation' element={
          <>
            <TaxConsultation></TaxConsultation>
            <ServiceSlider />

          </>
        } />

        <Route path='payroll-services' element={
          <>
            <PayrollSer></PayrollSer>
            <ServiceSlider />

          </>
        } />

        <Route path='insurance' element={
          <>
            <Insurance></Insurance>
            <ServiceSlider />

          </>
        } />

        <Route path='401k-assistance' element={
          <>
            <FourOneKAssistance></FourOneKAssistance>
            <ServiceSlider />

          </>
        } />

        <Route path='accounting' element={
          <>
            <Accounting></Accounting>
            <ServiceSlider />

          </>
        } />



        <Route path='irs-related-works' element={
          <>
            <Irs></Irs>
            <ServiceSlider />

          </>
        } />

        <Route path='nri-services' element={
          <>
            <NriService></NriService>
            <ServiceSlider />

          </>
        } />

        <Route path='privacy-policy' element={
          <>
            <PrivacyPolicy></PrivacyPolicy>
          </>
        } />

        <Route path='terms-of-service' element={
          <>
            <Terms></Terms>
          </>
        } />





        <Route path='contact-us' element={
          <>
            <section className='bg-about'>
              <Contact />
            </section>

          </>
        } />


        <Route path='appointment' element={
          <>
            <Appointment />
          </>
        } />


        <Route path='thank-you' element={
          <>
            <ThankYou></ThankYou>
          </>
        } />

        <Route path='tax-filing-deadline' element={
          <>
            <IndividualTaxFiling />
          </>
        } />

        <Route path='ITR-Tax-Filing' element={
          <>
            <ITRTaxFiling></ITRTaxFiling>
          </>
        } />
        <Route path='types-of-permit-in-usa' element={
          <>
            <TypesOfPermitInUSA></TypesOfPermitInUSA>
          </>
        } />

        <Route path='admendments-and-correction-charges-in-usa' element={
          <>
            <AdmendmentsAndCorrectionChargesInUsa></AdmendmentsAndCorrectionChargesInUsa>
          </>
        } />

        <Route path='new-corporation-in-the-usa' element={
          <>
            <NewCorporationInTheUSA></NewCorporationInTheUSA>
          </>
        } />

        <Route path='first-dba-filing-with-corporation-usa' element={
          <>
            <FIRSTDBAFilingWithCorporationUSA></FIRSTDBAFilingWithCorporationUSA>
          </>
        } />

        <Route path='second-dba-registration-usa' element={
          <>
            <SecondDBARegistrationUSA></SecondDBARegistrationUSA>
          </>
        } />

        <Route path='sales-tax-solution-usa' element={
          <>
            <SalesTaxSolutionUSA></SalesTaxSolutionUSA>
          </>
        } />

        <Route path='tobacco-licenses-in-usa' element={
          <>
            <TobaccoLicensesInUSA></TobaccoLicensesInUSA>
          </>
        } />

        <Route path='texas-alcoholic-beverage-commission-license-in-usa' element={
          <>
            <TexasAlcoholicBeverageCommissionLicenseInUSA></TexasAlcoholicBeverageCommissionLicenseInUSA>
          </>
        } />

        <Route path='texas-commission-on-environmental-quality-regulation-in-usa' element={
          <>
            <TCEQ></TCEQ>
          </>
        } />

        <Route path='weight-and-measurement-certificate-usa' element={
          <>
            <WMC></WMC>
          </>
        } />

        <Route path='money-services-business-license-usa' element={
          <>
            <MSB></MSB>
          </>
        } />

        <Route path='food-stamps-application-texas' element={
          <>
            <FSAT></FSAT>
          </>
        } />

        <Route path='health-permit-for-businesses-usa' element={
          <>
            <HPBU></HPBU>
          </>
        } />

        <Route path='occupancy-certificate-usa-requirements' element={
          <>
            <OCUR></OCUR>
          </>
        } />

        <Route path='food-permit-license-usa' element={
          <>
            <FPLU></FPLU>
          </>
        } />
        <Route path='lottery-business-license-usa' element={
          <>
            <LBLU></LBLU>
          </>
        } />
        <Route path='admin' element={

          <Admin />

        } />

      </Routes>


      {currentPage !== 'admin' && <Footer></Footer>}





      <AnimatedCursor
        innerSize={15} // Larger for the cross effect
        outerSize={40} // Outer ring size
        // innerScale={1}
        innerScale={0.5} // Scales down on hover
        outerScale={1.2}
        outerAlpha={1}
        hasBlendMode={false}
        innerStyle={{
          background: '#176cae',
          width: '12px',
          height: '12px',
          clipPath: 'polygon(0% 40%, 40% 40%, 40% 0%, 60% 0%, 60% 40%, 100% 40%, 100% 60%, 60% 60%, 60% 100%, 40% 100%, 40% 60%, 0% 60%)',
          zIndex: 999999,

        }}


        outerStyle={{
          zIndex: 999999,
          border: "2px solid #4e9049",
          backgroundColor: "transparent",
          borderRadius: "50%",
        }}
      />


      {/*  </BrowserRouter> */}
    </>

  );
}

export default App;
